@font-face {
    font-family: 'PorscheNext';
    src:    url('../fonts/PorscheNext-Regular.woff') format('woff');
}

@font-face {
    font-family: 'PorscheNextBold';
    src:    url('../fonts/PorscheNext-Bold.woff') format('woff');
}
.dh-mfc {

    * {
        font-family: 'PorscheNext' !important;
    }

    b {
        font-family: 'PorscheNextBold' !important;
    }

    hr {
        background-color: #EFF0F1!important;
        height: 3px!important;
    }

    .content-calculator {
        position: relative;
    }

    .c-compare-and-select {
        box-shadow: none!important;
        background-color: #EFF0F1;
        cursor: pointer;
        width: 100%;
    }

    .label-compare-and-select {
        cursor: pointer;
    }

    .c-compare-and-select--selected, .c-compare-and-select__hidden-input:checked+.c-compare-and-select {
        background-color: #D5001C!important;
    }

    .c-compare-and-select--selected, .c-compare-and-select__hidden-input:checked+.c-compare-and-select > .label-compare-and-select {
        color: #ffffff!important;
    }

    .c-btn {
        text-transform: none!important;
        background-color: #313639!important;
    }

    .c-btn:hover {
        background-color: #D5001C!important;
    }

    .c-btn--secondary {
        background-color: #D5001C!important;
        color: #ffffff!important;
        border: none!important;
    }

    .c-link__body {
        color: #D5001C!important;
        font-size: 16px!important;
        font-weight: bold!important;
        text-decoration: underline;
    }

    .c-info-icon {
        color: #000000!important;
    }

    .c-modal-porsche > .c-modal__wrapper > .c-modal__header > .c-modal__title__wrapper > .c-modal__title {
        display: none!important;
    }

    .c-modal-porsche > .c-modal__wrapper > .c-modal__footer > .c-modal__actions {
        justify-content: flex-start!important;
    }

    .c-modal-porsche > .c-modal__wrapper > .c-modal__content>*:last-child {
        margin-bottom: 0px!important
    }

    .c-modal-porsche > .c-modal__wrapper > .c-modal__header {
        padding: 16px 24px 0px 24px!important;
    }

    .c-modal-porsche > .c-modal__wrapper > .c-modal__footer {
        padding-top: 8px!important;
    }

    .c-tooltip-porsche {
        position: absolute!important;
    }

    .c-tooltip-porsche > .c-modal__wrapper {
        width: 100%!important;
        max-width: 100%!important;
        height: 100%!important;
        background-color: #EFF0F1!important;
        box-shadow: none!important;
        position: absolute!important;
        transform: none!important;
        top: 0!important;
        left: 0!important;
        display: flex;
        flex-direction: column; 
        justify-content: center;
    }

    .c-tooltip-porsche > .c-modal__overlay {
        display: none!important;
    }

    .c-tooltip-porsche > .c-modal__wrapper > .c-modal__header > .c-modal__title__wrapper > .c-modal__title {
        font-weight: bold!important;
    }

    .c-tooltip-porsche > .c-modal__wrapper > .c-modal__content {
        max-height: max-content!important;
    }

    .c-tooltip-porsche > .c-modal__wrapper > .c-modal__footer {
        display: none!important;
    }

    .gradient {
        display: none;
    }

    .c-modal {
        width: 100%;
    }

    .c-icon {
        text-decoration: none!important;
    }

    .c-compare-and-select-container {
        max-width: 100%!important;
        margin-left: 0px!important;
        margin-right: 0px!important;
        padding-left: 0px!important;
        padding-right: 0px!important;
    }

    @media (max-width: 720px) {
        .container-selectors {
            max-height: 300px;
            overflow: auto;
            padding-top: 20px;
            position: relative;
        }

        .gradient-hide {
            display: none;
        }

        .gradient-show,
        .gradient-porsche {
            display: block;
            height: 55px;
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
            z-index: 100;
            background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.3) 98%);
        }

        .c-modal {
            position: fixed!important;
        }
    }
}